export default __webpack_public_path__ + "static/media/sgb.316292e0.png";